import i18n, { Resource } from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// English
import enCommon from '../locales/en/common.json';
import enNavigation from '../locales/en/navigation.json';
import enSettings from '../locales/en/settings.json';
import enBookingsettings from '../locales/en/bookingsettings.json';
import enBookingwidget from '../locales/en/bookingwidget.json';
import enWaitlist from '../locales/en/waitlist.json';
import enAuth from '../locales/en/auth.json';
import enBooking from '../locales/en/booking.json';
import enClients from '../locales/en/clients.json';
import enDashboard from '../locales/en/dashboard.json';
import enInventory from '../locales/en/inventory.json';
import enAppointments from '../locales/en/appointments.json';
import enTimeslotselector from '../locales/en/timeslotselector.json';
import enServices from '../locales/en/services.json';
import enInbox from '../locales/en/inbox.json';
import enBilling from '../locales/en/billing.json';
import enProfile from '../locales/en/profile.json';
import enNotifications from '../locales/en/notifications.json';
import enAnalytics from '../locales/en/analytics.json';
import enStaff from '../locales/en/staff.json';
import enReviews from '../locales/en/reviews.json';
import enManageBooking from '../locales/en/manageBooking.json';
import enGrowth from '../locales/en/growth.json';
import enLicensing from '../locales/en/licensing.json';

// Czech
import csCommon from '../locales/cs/common.json';
import csNavigation from '../locales/cs/navigation.json';
import csSettings from '../locales/cs/settings.json';
import csBooking from '../locales/cs/booking.json';
import csBookingsettings from '../locales/cs/bookingsettings.json';
import csBookingwidget from '../locales/cs/bookingwidget.json';
import csWaitlist from '../locales/cs/waitlist.json';
import csAuth from '../locales/cs/auth.json';
import csClients from '../locales/cs/clients.json';
import csDashboard from '../locales/cs/dashboard.json';
import csInventory from '../locales/cs/inventory.json';
import csAppointments from '../locales/cs/appointments.json';
import csTimeslotselector from '../locales/cs/timeslotselector.json';
import csServices from '../locales/cs/services.json';
import csInbox from '../locales/cs/inbox.json';
import csBilling from '../locales/cs/billing.json';
import csProfile from '../locales/cs/profile.json';
import csNotifications from '../locales/cs/notifications.json';
import csAnalytics from '../locales/cs/analytics.json';
import csStaff from '../locales/cs/staff.json';
import csReviews from '../locales/cs/reviews.json';
import csManageBooking from '../locales/cs/manageBooking.json';
import csGrowth from '../locales/cs/growth.json';
import csLicensing from '../locales/cs/licensing.json';

// Russian
import ruCommon from '../locales/ru/common.json';
import ruNavigation from '../locales/ru/navigation.json';
import ruSettings from '../locales/ru/settings.json';
import ruBooking from '../locales/ru/booking.json';
import ruBookingsettings from '../locales/ru/bookingsettings.json';
import ruBookingwidget from '../locales/ru/bookingwidget.json';
import ruWaitlist from '../locales/ru/waitlist.json';
import ruAuth from '../locales/ru/auth.json';
import ruClients from '../locales/ru/clients.json';
import ruDashboard from '../locales/ru/dashboard.json';
import ruInventory from '../locales/ru/inventory.json';
import ruAppointments from '../locales/ru/appointments.json';
import ruTimeslotselector from '../locales/ru/timeslotselector.json';
import ruServices from '../locales/ru/services.json';
import ruInbox from '../locales/ru/inbox.json';
import ruBilling from '../locales/ru/billing.json';
import ruProfile from '../locales/ru/profile.json';
import ruNotifications from '../locales/ru/notifications.json';
import ruAnalytics from '../locales/ru/analytics.json';
import ruStaff from '../locales/ru/staff.json';
import ruReviews from '../locales/ru/reviews.json';
import ruManageBooking from '../locales/ru/manageBooking.json';
import ruGrowth from '../locales/ru/growth.json';
import ruLicensing from '../locales/ru/licensing.json';

// Spanish
import esCommon from '../locales/es/common.json';
import esNavigation from '../locales/es/navigation.json';
import esSettings from '../locales/es/settings.json';
import esReviews from '../locales/es/reviews.json';
import esManageBooking from '../locales/es/manageBooking.json';
import esLicensing from '../locales/es/licensing.json';

const resources = {
  en: {
    common: enCommon,
    navigation: enNavigation,
    settings: enSettings,
    bookingsettings: enBookingsettings,
    bookingwidget: enBookingwidget,
    auth: enAuth,
    booking: enBooking,
    waitlist: enWaitlist,
    clients: enClients,
    dashboard: enDashboard,
    inventory: enInventory,
    appointments: enAppointments,
    timeslotselector: enTimeslotselector,
    analytics: enAnalytics,
    services: enServices,
    inbox: enInbox,
    billing: enBilling,
    profile: enProfile,
    notifications: enNotifications,
    staff: enStaff,
    reviews: enReviews,
    manageBooking: enManageBooking,
    growth: enGrowth,
    licensing: enLicensing,
  },
  cs: {
    common: csCommon,
    navigation: csNavigation,
    settings: csSettings,
    booking: csBooking,
    bookingsettings: csBookingsettings,
    bookingwidget: csBookingwidget,
    waitlist: csWaitlist,
    auth: csAuth,
    clients: csClients,
    dashboard: csDashboard,
    inventory: csInventory,
    appointments: csAppointments,
    timeslotselector: csTimeslotselector,
    analytics: csAnalytics,
    services: csServices,
    inbox: csInbox,
    billing: csBilling,
    profile: csProfile,
    notifications: csNotifications,
    staff: csStaff,
    reviews: csReviews,
    manageBooking: csManageBooking,
    growth: csGrowth,
    licensing: csLicensing,
  },
  ru: {
    common: ruCommon,
    navigation: ruNavigation,
    settings: ruSettings,
    booking: ruBooking,
    bookingsettings: ruBookingsettings,
    bookingwidget: ruBookingwidget,
    waitlist: ruWaitlist,
    auth: ruAuth,
    clients: ruClients,
    dashboard: ruDashboard,
    inventory: ruInventory,
    appointments: ruAppointments,
    timeslotselector: ruTimeslotselector,
    analytics: ruAnalytics,
    services: ruServices,
    inbox: ruInbox,
    billing: ruBilling,
    profile: ruProfile,
    notifications: ruNotifications,
    staff: ruStaff,
    reviews: ruReviews,
    manageBooking: ruManageBooking,
    growth: ruGrowth,
    licensing: ruLicensing,
  },
  es: {
    common: esCommon,
    navigation: esNavigation,
    settings: esSettings,
    reviews: esReviews,
    manageBooking: esManageBooking,
    licensing: esLicensing,
  },
} as const satisfies Resource;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: [
      'common',
      'navigation',
      'settings',
      'bookingsettings',
      'bookingwidget',
      'waitlist',
      'auth',
      'booking',
      'timeslotselector',
      'clients',
      'dashboard',
      'inventory',
      'appointments',
      'analytics',
      'services',
      'inbox',
      'billing',
      'notifications',
      'profile',
      'staff',
      'reviews',
      'manageBooking',
      'growth',
      'licensing'
    ],
    resources,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;

// Debug
if (typeof window !== 'undefined') {
  // @ts-ignore
  window.i18next = i18n;
}